import { Trans, t } from '@lingui/macro';
import { Menu, Box, Typography, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function CloseDialogPrompt(props) {
    const { open, onClick, onClose, children } = props;
    return (<Menu open={open} onClose={onClose} target={children}>
      <Box display="flex" flexDirection="column" gap="md" p="lg">
        <Typography $appearance="300" $fontSize="small">
          <Trans comment="Key Dialog - Prompt to save client secret">
            The Client secret cannot be retrieved later. Make sure to save it before moving on.
          </Trans>
        </Typography>
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" gap="md" width="100%">
          <Typography $appearance="300" $fontSize="small">
            <Trans comment="Key Dialog - Prompt to save client secret">
              Did you save the Client secret?
            </Trans>
          </Typography>
          <Box display="flex" flexDirection="row" alignItems="center" gap="md">
            <IconButton type="button" $round size="small" appearance="ghost" onClick={onClose} aria-label={t({
            message: 'Cancel close prompt',
            comment: 'prompt to close client secret - Cancel button',
        })}>
              <Falcon icon="xmark"/>
            </IconButton>
            <IconButton type="button" $round size="small" onClick={onClick} aria-label={t({
            message: 'Close prompt',
            comment: 'prompt to close client secret - Close button',
        })}>
              <Falcon icon="check"/>
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Menu>);
}
